module.exports = __webpack_public_path__ + "img/hr-assembling-machine-3.4791fc5e.png";